<template>
	<div class="book-viewer__sidebar__contents sidebar">
        <div class="sidebar__info" v-if="keySidebarActive === keyTabInfo">
        	<div class="sidebar__media__head">
        		<div class="book-viewer__sidebar__contents__wrap">
		        	<h3 class="sidebar__title primary-color-txt font-sanpro-semibold font-size-22">Thông tin</h3>
		        </div>
        	</div>
            <div class="sidebar__info__result">
            	<vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
            		<div class="book-viewer__sidebar__contents__wrap">
            			<div class="sidebar__info__list">
            				<table class="margin-0 p-0 full-width">
            					<tbody>
            						<tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Môn học</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.subjectName }}</td>
            						</tr>
            						<tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Lớp</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.className }}</td>
            						</tr>
            						<tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Bộ sách</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.bookGroupName }}</td>
            						</tr>
            						<tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Tác giả</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.author }}</td>
            						</tr>
            						<tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Bản quyền</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.copyright }}</td>
            						</tr>
            						<!-- <tr>
            							<td class="font-size-16 secondary-color-txt font-sanpro-semibold">Hoàn thành</td>
            							<td class="font-size-16 primary-color-txt font-sanpro">{{ dataSource.completeTime }}</td>
            						</tr> -->
            					</tbody>
            				</table>
            			</div>
                    <p class="font-size-15 primary-color sidebar__info__type" @click="showModalReadmore">
                        {{ dataSource.bookLessonPlanTypeId === 1 && dataSource.isPublish ? 'Học liệu đã được NXBGDVN phê duyệt' : 'Học liệu Hành trang số sản xuất' }}
                    </p>
        			<p class="sidebar__desc font-size-16 primary-color-txt">
        				Người dùng được khuyến nghị sử dụng chức năng Tải xuống để trải nghiệm Bài giảng tham khảo toàn diện nhất.
        			</p>
                  <div class="sidebar__download__list">
                    <ul class="margin-0 p-0">
                        <li class="item display-flex-center" v-if="dataSource && dataSource.lessonPlan && dataSource.lessonPlan.path">
                          <figure class="item__icon margin-0 p-0">
                            <img src="@/assets/images/power.png" alt="Powerpoint" />
                          </figure>
                          <div class="item__name word-excerpt">
                            {{ dataSource.lessonPlan.pathView }}
                          </div>
                          <!-- <a class="item__action" href="javascript:;" @click="downloadDocs(`${urlFile}/${dataSource.lessonPlan.path}`, dataSource.lessonPlan.pathView, true)">
                            <i class="icon-download"></i>
                          </a> -->
                        </li>
                        <li class="item display-flex-center" v-if="dataSource.script && dataSource.script.path">
                          <figure class="item__icon margin-0 p-0" v-if="dataSource && dataSource.lessonPlan && dataSource.lessonPlan.path">
                            <img v-if="checkVideo(dataSource.lessonPlan.path)" src="@/assets/images/youtobe.png" alt="Video" />
                            <img v-else-if="checkPowerpoint(dataSource.lessonPlan.path)" src="@/assets/images/power.png" alt="Powerpoint" />
                            <img v-else-if="checkPdf(dataSource.lessonPlan.path)" src="@/assets/images/pdf.png" alt="Pdf" />
                          </figure>
                          <div class="item__name word-excerpt">{{ dataSource.script.pathView ? dataSource.script.pathView : '...' }}</div>
                          <!-- <a class="item__action" href="javascript:;" @click="downloadDocs(`${urlFile}/${dataSource.script.path}`, dataSource.lessonPlan.pathView, true)">
                            <i class="icon-download"></i>
                          </a> -->
                        </li>
                    </ul>
                  </div>
	            	</div>
            	</vue-custom-scrollbar>
            </div>
        </div>
        <div class="sidebar__download" v-else-if="keySidebarActive === keyTabDownload">
        	<div class="sidebar__media__head">
        		<div class="book-viewer__sidebar__contents__wrap">
		        	<h3 class="sidebar__title primary-color-txt font-sanpro-semibold font-size-22">Tải bài giảng</h3>
		        </div>
        	</div>
            <div class="sidebar__download__result">
            	<vue-custom-scrollbar class="scroll-area scroll-area__sidebar" :settings="settingsViewBookSidebar">
            		<div class="book-viewer__sidebar__contents__wrap">
            			<p class="sidebar__desc font-size-16 primary-color-txt">
            				Giáo viên cần tải xuống tất cả tài liệu để sử dụng bài giảng 1 cách tốt nhất.
            			</p>
            			<div class="sidebar__download__list">
            				<ul class="margin-0 p-0">
            				    <li class="item display-flex-center" v-if="dataSource && dataSource.lessonPlan && dataSource.lessonPlan.path">
            				    	<figure class="item__icon margin-0 p-0">
										        <img src="@/assets/images/power.png" alt="Powerpoint" />
            				    	</figure>
            				    	<div class="item__name word-excerpt">
            				    		{{ dataSource.lessonPlan.pathView }}
            				    	</div>
            				    	<!-- <a class="item__action" href="javascript:;" @click="downloadDocs(`${urlFile}/${dataSource.lessonPlan.path}`, dataSource.lessonPlan.pathView, true)">
            				    		<i class="icon-download"></i>
            				    	</a> -->
            				    </li>
            				    <li class="item display-flex-center" v-if="dataSource.script && dataSource.script.path">
            				    	<figure class="item__icon margin-0 p-0" v-if="dataSource && dataSource.lessonPlan && dataSource.lessonPlan.path">
            				    		<img v-if="checkVideo(dataSource.lessonPlan.path)" src="@/assets/images/youtobe.png" alt="Video" />
										<img v-else-if="checkPowerpoint(dataSource.lessonPlan.path)" src="@/assets/images/power.png" alt="Powerpoint" />
										<img v-else-if="checkPdf(dataSource.lessonPlan.path)" src="@/assets/images/pdf.png" alt="Pdf" />
										<img v-else src="@/assets/images/document1.png" alt="Word" />
            				    	</figure>
            				    	<div class="item__name word-excerpt">{{ dataSource.script.pathView ? dataSource.script.pathView : '...' }}</div>
            				    	<!-- <a class="item__action" href="javascript:;" @click="downloadDocs(`${urlFile}/${dataSource.script.path}`, dataSource.lessonPlan.pathView, true)">
            				    		<i class="icon-download"></i>
            				    	</a> -->
            				    </li>
            				</ul>
            			</div>
	            	</div>
            	</vue-custom-scrollbar>
            </div>
        </div>
      <ModalReadMoreLinkType v-if="openModalReadmore" />
    </div>
</template>

<script>
	import vueCustomScrollbar from 'vue-custom-scrollbar'
    import { APP_CONFIG } from '@/utils/constants'
    import { DETAIL_TAB_INFO, DETAIL_TAB_DOWNLOAD, ID_MODAL_READ_LINK_TYPE } from './../../_store/constants'
    import mixinsFiles from '@/components/content-files/mixinsFiles'

	export default {
		name: 'Sidebar',
		mixins: [ mixinsFiles ],
		props: {
			keySidebarActive: String,
			dataSource: Object
		},
		components: {
			vueCustomScrollbar,
      ModalReadMoreLinkType: () => import('./../list/ModalReadMoreLinkType.vue')
		},
		data () {
			return {
				keyTabInfo: DETAIL_TAB_INFO,
    		keyTabDownload: DETAIL_TAB_DOWNLOAD,
    		settingsViewBookSidebar: {
          maxScrollbarLength: 300
        },
        urlFile: APP_CONFIG.urlPlatformCmsImg,
        openModalReadmore: false
			}
		},
		methods: {
      showModalReadmore () {
        if (this.openModalReadmore) {
          this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
        } else {
          this.openModalReadmore = true
          setTimeout(() => {
            this.$bvModal.show(ID_MODAL_READ_LINK_TYPE)
          }, 500);
        }
      },
		}
	}
</script>

<style lang="scss" scoped>
	@import "./../../../../assets/scss/variables";
    @import "./../../../../assets/scss/mixins";
	@import "./../../../../assets/scss/general";

	.sidebar {
		&__title {
			margin-bottom: 15px;
		}
	}

	.sidebar__info {
		table {
			margin-bottom: 30px;

			tr {
				td {
					@extend .primary-color-txt;
					padding: 6px 8px;
					vertical-align: top;

					&:first-child {
						@extend .secondary-color-txt;
						width: 110px;
						padding-left: 0;
					}
				}
			}
		}

    &__type {
      cursor: pointer;

      &:hover {
        @extend .primary-color;
      }
    }
	}

	.sidebar__download {
		.sidebar__desc {
			margin-bottom: 25px;
		}

		&__list {
			ul {

				.item {
					@extend .list-style-none;
					padding: 12px 0;
					border-bottom: 1px solid #E4E6EB;

					&:first-child {
						border-top: 1px solid #E4E6EB;
					}

					&__icon, &__action {
						max-width: 18px;
						@extend .text-center;
						@extend .position-rel;
					}

					&__icon, &__name {
						margin-right: 7px;
					}

					&__name {
						width: calc(100% - 50px);
						// @extend .font-size-14;
						@extend .primary-color-txt;
					}
				}
			}
		}
	}
</style>